import { createSelector, Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { AuthenticationState } from 'features/authentication/types'

const navigationUserStateSelector: Selector<ReduxState, AuthenticationState> = (state) => state.authentication

export default createSelector(navigationUserStateSelector, (state) => state.user)
